var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.width }),attrs:{"id":"tinymce"}},[_c('vue-tinymce',{attrs:{"value":_vm.value,"init":_vm.setting},on:{"input":function (val) { return _vm.$emit('input', val); }}}),_vm._v(" "),_c('div',{staticClass:"notice"},[_vm._v(_vm._s(_vm.notice))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33b328f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/formComponents/sky-rich-text.vue
// module id = null
// module chunks = 